var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect } from "react";
import classNames from "classnames";
import NotificationAPI from "antd/es/notification";
import { useGetGerudoContainer } from "../hooks";
import IconWrapper from "../Icons/IconWrapper";
import { IconSizes } from "../Icons/PropTypes/IconSizes";
import NotificationContent from "./NotificationContent";
const showNotificationFromInstance = (instance, args) => {
    const { className, notification } = args, props = __rest(args, ["className", "notification"]);
    const { closeButtonAriaLabel, colorize, type, message, description } = notification, notif = __rest(notification, ["closeButtonAriaLabel", "colorize", "type", "message", "description"]);
    instance.open(Object.assign(Object.assign(Object.assign({}, props), notif), { className: classNames("gerudo-notification", className, type, { colorized: colorize }), closeIcon: React.createElement(IconWrapper, { "aria-label": closeButtonAriaLabel || "close", name: "X", size: IconSizes.Medium }), message: React.createElement(NotificationContent, { message: message, description: description, type: type }) }));
};
// By default, bind to the global Notification instance. Once the component mounts,
// the instance will be bound to the Notification instance returned from the
// useNotification hook. The usage of this instance instead of the global one
// allows to preserve the context of the app inside the notification
export let showNotification = showNotificationFromInstance.bind(null, NotificationAPI);
export const hideNotification = (key) => {
    NotificationAPI.close(key);
};
export const hideAllNotifications = () => {
    NotificationAPI.destroy();
};
const Notifications = (_a) => {
    var { notification, visible } = _a, props = __rest(_a, ["notification", "visible"]);
    const { getGerudoContainer: getContainer, ref } = useGetGerudoContainer();
    const [instance, contextHolder] = NotificationAPI.useNotification();
    useEffect(() => {
        showNotification = showNotificationFromInstance.bind(null, instance);
    }, []);
    useEffect(() => {
        if (visible) {
            showNotification(Object.assign({ getContainer,
                notification }, props));
        }
    }, [visible]);
    return React.createElement("div", { ref: ref }, contextHolder);
};
export default Notifications;
export { Notifications };
//# sourceMappingURL=Notifications.js.map